import platform from "platform";

import { IpInfoResponse } from "models/User";

import { getAPIService, postAPIService } from "./BaseServce";

export const login = async (
  email: string,
  password: string,
  eventId?: string,
  ipInfo?: IpInfoResponse,
) => {
  const res = await postAPIService("/auth/login", {
    email,
    password,
    event_id: eventId,
    ip: ipInfo?.ip,
    geo_data: ipInfo,
    platform_data: platform,
  });
  return res.data;
};

export const register = async (
  firstName: string,
  lastName: string,
  email: string,
  role: string,
  password: string,
  source: string,
  inviteCode?: string,
  eventId?: string,
  ipInfo?: IpInfoResponse,
) => {
  const res = await postAPIService("/auth/registration", {
    email,
    password,
    role,
    source,
    first_name: firstName,
    last_name: lastName,
    invite_code: inviteCode,
    event_id: eventId,
    ip: ipInfo?.ip,
    geo_data: ipInfo,
    platform_data: platform,
  });
  return res.data;
};

export const forgotPassword = async (email: string) => {
  const res = await postAPIService("/auth/forgot-password", {
    email,
  });
  return res.data;
};

export const resetPassword = async (
  userIdentifier: string,
  token: string,
  password: string,
  isNewUser = false,
) => {
  const res = await postAPIService("/auth/reset-password", {
    user_identifier: userIdentifier,
    token,
    password,
    is_new_user: isNewUser,
  });
  return res.data;
};

export const validateInviteToken = async (token: string) => {
  const res = await getAPIService("/auth/validate-invite-token", {
    token,
  });
  return res.data;
};

export const requestEmailVerification = async (
  email: string,
  userId: number,
) => {
  const res = await getAPIService("/auth/verify-email", {
    email,
    user_id: userId,
  });
  return res.data;
};

export const verifyEmail = async (
  userId: number,
  email: string,
  token: string,
) => {
  const res = await postAPIService("/auth/verify-email", {
    user_id: userId,
    email,
    token,
  });
  return res.data;
};
